import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';

let loaderContainer;
if (document.getElementById('loader-container')) {
  loaderContainer = document.getElementById('loader-container');
} else {
  loaderContainer = document.createElement('div');
  loaderContainer.id = 'loader-container';
  document.body.appendChild(loaderContainer);
}

const Loader = props => ReactDOM.createPortal(
  <LoaderContainer>
    <CircularProgress {...props} />
  </LoaderContainer>,
  loaderContainer,
);

export default Loader;

const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999 !important;
`;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js